import React from 'react';
import './StartScreen.css';

const StartScreen = ({ onStartGame }) => {
  return (
    <div className="start-screen">
      <div className="screen-header">
        <div className="header-logos">
<img src="/saudi95.png" alt="شعار اليوم الوطني 95" className="national-logo" />          
<img src="/benchlogocropped.png" alt="شعار المقهى" className="cafe-logo" />
          
        </div>
      </div>
      
      <div className="start-content">
        <div className="cafe-branding">
          <h1 className="app-title">تحدي بنش</h1>
        </div>
        
        <div className="welcome-text">
          <p>اختبر معلوماتك واحصل على خصم يصل إلى 50%</p>
        </div>
        
        <div className="game-rules">
          <div className="rule-item">
            <div className="rule-icon">🧠</div>
            <span>5 أسئلة متنوعة</span>
          </div>
          <div className="rule-item">
            <div className="rule-icon">⏰</div>
            <span>5 ثوان لكل سؤال</span>
          </div>
          <div className="rule-item">
            <div className="rule-icon">💰</div>
            <span>10% خصم لكل إجابة صحيحة</span>
          </div>
          <div className="rule-item">
            <div className="rule-icon">🎯</div>
            <span>حد أقصى 50% خصم</span>
          </div>
        </div>
        
        <button className="start-button" onClick={onStartGame}>
          <span>ابدأ المسابقة</span>
          <div className="button-icon">🚀</div>
        </button>
      </div>
      
      <div className="footer-strap">
        <img src="/footerstrap.png" alt="شريط سفلي" className="footer-image" />
      </div>
    </div>
  );
};

export default StartScreen;
